import React, { useState, useEffect, useRef } from "react";
import "./ScrollButton.css";

interface ScrollButtonProps {
    scrollContainerRef: React.RefObject<HTMLDivElement | null>;
}

const ScrollButton = ({ scrollContainerRef }: ScrollButtonProps) => {
    const [visible, setVisible] = useState(false);
    const [isNearby, setIsNearby] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const toggleVisible = () => {
            const scrolled = scrollContainerRef.current?.scrollTop || 0;
            if (scrolled > 300) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        const handleMouseMove = (e: MouseEvent) => {
            if (!buttonRef.current) return;

            const rect = buttonRef.current.getBoundingClientRect();
            const buttonCenterX = rect.left + rect.width / 2;
            const buttonCenterY = rect.top + rect.height / 2;

            const distance = Math.sqrt(
                Math.pow(e.clientX - buttonCenterX, 2) +
                Math.pow(e.clientY - buttonCenterY, 2)
            );

            setIsNearby(distance < 150);
        };

        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener("scroll", toggleVisible);
            document.addEventListener("mousemove", handleMouseMove);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", toggleVisible);
            }
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, [scrollContainerRef]);

    const scrollToTop = () => {
        scrollContainerRef.current?.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <button
            ref={buttonRef}
            className="button"
            onClick={scrollToTop}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                display: visible ? "inline" : "none",
                opacity: isHovered ? 1 : (isNearby ? 0.5 : 0)
            }}
        >
            ↑
        </button>
    )
};

export default ScrollButton;